export default "__VITE_ASSET__6FuWWc1T__"